import React from 'react'
import { useIntl } from 'react-intl'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { errorActions } from '@/redux/actions'
import { Box, Col, Icon, RfButton, Typography, Row } from '@vibialighting/ui-kit'

const layerStyles = {
	width: '100vw',
	height: '100vh',
	zIndex: 1005,
	backgroundColor: 'rgba(255, 2555, 255,  0.9)',
	position: 'fixed',
	top: 0,
	left: 0
}

const RetryActionLayer = () => {

	const error = useSelector((store) => store.error, shallowEqual)
	const dispatch = useDispatch()
	const { formatMessage } = useIntl()

	return error?.actionsToRetry?.showLayer ? (
		<Box style={layerStyles}>
			<Row disableGutters justifyContent="center" alignItems="center" style={{ height: '100%' }}>
				<Col width="auto">
					<Box hAlign="center">
						<Icon color="primary-lima" size={4}>warning</Icon>
					</Box>
					<Box paddingTop={5}>
						<Typography variant="body" weight="regular" align="center">
							{formatMessage({ id: 'retryActionLayer.message' })}
						</Typography>
					</Box>
					<Box marginTop={6}>
						<Row justifyContent="center" alignItems="center">
							<Col with="auto">
								<RfButton variant="fill" onClick={() => dispatch(errorActions.retryActions())}> {formatMessage({ id: 'retryActionLayer.btn.retry' })}</RfButton>
							</Col>
							<Col with="auto">
								<RfButton variant="ghost" onClick={() => dispatch(errorActions.resetActions())}> {formatMessage({ id: 'retryActionLayer.btn.dismiss' })}</RfButton>
							</Col>
						</Row>
					</Box>
				</Col>
			</Row>
		</Box>
	) : null
}

export default RetryActionLayer
